import {NgcCookieConsentConfig} from 'ngx-cookieconsent';
import {environment} from '../../../environments/environment';

/*
export type NgcCookiePosition = 'top' | 'bottom' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
export type NgcCookieLayout = 'basic' | 'basic-close' | 'basic-header' | string;
export type NgcCookieTheme = 'block' | 'edgeless' | 'classic';
NgcCookieCompliance = 'info' | 'opt-in' | 'opt-out';
 */

export const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.ccUrl
  },
  palette: {
    popup: {
      background: '#000'
    },
    button: {
      background: '#283593',
      text: "white"
    }
  },
  theme: 'edgeless',
  position: 'bottom-right',
  type: 'opt-out',
  layout: 'my-custom-layout',
  layouts: {
    "my-custom-layout": '{{messagelink}}{{compliance}}'
  },
  elements:{
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_blank" rel="noopener">{{cookiePolicyLink}}</a>,
      <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_blank" rel="noopener">{{privacyPolicyLink}}</a> and our
      <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="{{tosHref}}" target="_blank" rel="noopener">{{tosLink}}</a>
    </span>
    `,
  },
  content:{
    message: 'By using our site, you acknowledge that you have read and understand our ',

    cookiePolicyLink: 'Cookie Policy',
    cookiePolicyHref: 'cookie',

    privacyPolicyLink: 'Privacy Policy',
    privacyPolicyHref: 'privacy',

    tosLink: 'Terms of Service',
    tosHref: 'tos',
  }
};
